import { defineComponent } from 'vue';
import { mapState } from 'pinia'

import { useConfigStore } from '~/store/configuration.store';

export default defineComponent({
    data() {
        return {
            logo: require('@/elichens-icon-colored-white-e.svg').default,
        };
    },
    computed: {
        ...mapState(useConfigStore, ['VERSION']),
        year() {
            return new Date().getFullYear();
        },
    },
});